import {
  createFileRoute,
  useLoaderData,
  useSearch,
} from "@tanstack/react-router";
import { FamilyInfo } from "@crm/components/families/family-info";
import { FamilyStatusBar } from "@crm/components/families/family-status-bar";
import { FamilyOverview } from "@crm/pages/family-overview";
import { CapitalGainsDialog } from "@crm/components/portfolio/reports/capital-gains-dialog";
import { PortfolioValuation } from "@crm/components/portfolio/reports/portfolio-valuation";
import { Page } from "@core/components/layout/page";
import { familyDetailsQueryOptions } from "creso-core/hooks";
import { Route as RootRoute } from "@/routes/__root";
import { RiskProfilerDialog } from "@crm/components/risk-profile/risk-profile";

function FamilyLayout() {
  useLoaderData({ from: "/(auth)/_headed/clients/families/$id" });

  return (
    <Page className="lg:flex-row size-full gap-2">
      <Page.Sidebar className="px-4 py-5 overflow-auto">
        <FamilyInfo />
      </Page.Sidebar>
      <Page.StatusBar className="[&>div]:w-full">
        <FamilyStatusBar />
      </Page.StatusBar>
      <Page.Content className="h-full bg-background">
        <FamilyOverview />
      </Page.Content>
    </Page>
  );
}

export const Route = createFileRoute("/(auth)/_headed/clients/families/$id")({
  component: function FamilyPage() {
    const { family } = Route.useLoaderData();
    const { modal, family_id } = useSearch({
      from: RootRoute.id,
      select: (search) => ({
        modal: search?.modal,
        family_id: search?.family_id,
      }),
    });

    return (
      <>
        <FamilyLayout />
        {modal === "risk-profile" ? <RiskProfilerDialog /> : null}
        {modal === "capital-gains" && family_id === family.id ? (
          <CapitalGainsDialog family={family} />
        ) : null}
        {modal === "portfolio-valuation" && family_id === family.id ? (
          <PortfolioValuation family={family} />
        ) : null}
      </>
    );
  },
  loader: async ({ context, params }) => {
    const { queryClient } = context;
    const family = await queryClient.fetchQuery(
      familyDetailsQueryOptions(Number(params.id))
    );
    return { family };
  },
});
